import React, { useEffect, useState } from 'react';
import { styles as st } from './Layout';

const VACIO = { usuario: '', password: '', nombre_usuario: '', tipo_usuario: 'Broker', inmobiliaria_id: '', broker_id: '', activo: true };

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [inmobiliarias, setInmobiliarias] = useState([]);
  const [form, setForm] = useState(VACIO);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState('');

  const load = async () => {
    const [u, b, i] = await Promise.all([
      fetch('/api/usuarios').then((r) => r.json()),
      fetch('/api/catalogos/brokers').then((r) => r.json()),
      fetch('/api/catalogos/inmobiliarias').then((r) => r.json()),
    ]);
    setUsuarios(u);
    setBrokers(b);
    setInmobiliarias(i);
  };

  useEffect(() => { load(); }, []);

  const abrirNuevo = () => { setForm(VACIO); setEditId(null); setShowForm(true); setError(''); };
  const abrirEditar = (u) => {
    setForm({ ...VACIO, ...u, password: '', inmobiliaria_id: u.inmobiliaria_id || '', broker_id: u.broker_id || '' });
    setEditId(u.id);
    setShowForm(true);
    setError('');
  };

  const guardar = async (e) => {
    e.preventDefault();
    setError('');
    const body = {
      ...form,
      inmobiliaria_id: form.inmobiliaria_id || null,
      broker_id: form.broker_id || null,
    };
    const url = editId ? `/api/usuarios/${editId}` : '/api/usuarios';
    const method = editId ? 'PUT' : 'POST';
    const r = await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    const d = await r.json();
    if (!r.ok) { setError(d.error || 'Error al guardar'); return; }
    setShowForm(false);
    load();
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este usuario?')) return;
    await fetch(`/api/usuarios/${id}`, { method: 'DELETE' });
    load();
  };

  return (
    <div style={st.card}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={st.sectionTitle}>Usuarios</h2>
        <button style={st.btnAccent} onClick={abrirNuevo}>+ Nuevo usuario</button>
      </div>

      {showForm && (
        <form onSubmit={guardar} style={{ marginTop: 20, marginBottom: 20, borderTop: '1px solid #eee', borderBottom: '1px solid #eee', paddingTop: 16, paddingBottom: 16 }}>
          {error && <div style={{ color: '#dc2626', marginBottom: 10, fontSize: 13 }}>{error}</div>}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <label style={st.label}>Usuario</label>
              <input style={st.input} value={form.usuario} onChange={(e) => setForm({ ...form, usuario: e.target.value })} required disabled={!!editId} />
            </div>
            <div>
              <label style={st.label}>{editId ? 'Nueva contraseña (opcional)' : 'Contraseña'}</label>
              <input type="password" style={st.input} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required={!editId} />
            </div>
            <div>
              <label style={st.label}>Nombre completo</label>
              <input style={st.input} value={form.nombre_usuario} onChange={(e) => setForm({ ...form, nombre_usuario: e.target.value })} required />
            </div>
            <div>
              <label style={st.label}>Tipo de usuario</label>
              <select style={st.input} value={form.tipo_usuario} onChange={(e) => setForm({ ...form, tipo_usuario: e.target.value })}>
                <option value="Administrador">Administrador</option>
                <option value="Broker">Broker</option>
                <option value="Inmobiliaria">Inmobiliaria</option>
              </select>
            </div>
            {form.tipo_usuario === 'Broker' && (
              <div>
                <label style={st.label}>Broker asignado</label>
                <select style={st.input} value={form.broker_id} onChange={(e) => setForm({ ...form, broker_id: e.target.value })} required>
                  <option value="">Selecciona…</option>
                  {brokers.map((b) => <option key={b.id} value={b.id}>{b.nombre}</option>)}
                </select>
              </div>
            )}
            {form.tipo_usuario === 'Inmobiliaria' && (
              <div>
                <label style={st.label}>Inmobiliaria asignada</label>
                <select style={st.input} value={form.inmobiliaria_id} onChange={(e) => setForm({ ...form, inmobiliaria_id: e.target.value })} required>
                  <option value="">Selecciona…</option>
                  {inmobiliarias.map((i) => <option key={i.id} value={i.id}>{i.nombre}</option>)}
                </select>
              </div>
            )}
            <div>
              <label style={st.label}>Activo</label>
              <select style={st.input} value={form.activo ? '1' : '0'} onChange={(e) => setForm({ ...form, activo: e.target.value === '1' })}>
                <option value="1">Sí</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
          <div style={{ marginTop: 20 }}>
            <button type="submit" style={st.btnPrimary}>Guardar</button>{' '}
            <button type="button" style={st.btnGhost} onClick={() => setShowForm(false)}>Cancelar</button>
          </div>
        </form>
      )}

      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 12 }}>
        <thead>
          <tr>
            <th style={st.th}>Usuario</th>
            <th style={st.th}>Nombre</th>
            <th style={st.th}>Tipo</th>
            <th style={st.th}>Broker / Inmobiliaria</th>
            <th style={st.th}>Activo</th>
            <th style={st.th}></th>
          </tr>
        </thead>
        <tbody>
          {usuarios.map((u) => (
            <tr key={u.id}>
              <td style={st.td}>{u.usuario}</td>
              <td style={st.td}>{u.nombre_usuario}</td>
              <td style={st.td}>{u.tipo_usuario}</td>
              <td style={st.td}>{u.broker_nombre || u.inmobiliaria_nombre || '—'}</td>
              <td style={st.td}>{u.activo ? 'Sí' : 'No'}</td>
              <td style={st.td}>
                <button style={st.btnGhost} onClick={() => abrirEditar(u)}>Editar</button>{' '}
                <button style={st.btnDanger} onClick={() => eliminar(u.id)}>Eliminar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
